// Shimmer loading skeletons for a premium perceived-performance feel
export function Skeleton({ className = "" }) {
  return <div className={`shimmer rounded-xl ${className}`} />;
}

export function VideoCardSkeleton() {
  return (
    <div className="glass-card overflow-hidden" data-testid="skeleton-video">
      <Skeleton className="w-full aspect-video rounded-none" />
      <div className="p-5 space-y-2.5">
        <Skeleton className="h-2.5 w-16" />
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    </div>
  );
}

export function ResourceCardSkeleton() {
  return (
    <div className="glass-card overflow-hidden" data-testid="skeleton-resource">
      <Skeleton className="w-full h-40 rounded-none" />
      <div className="p-6 space-y-3">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-3.5 w-full" />
        <Skeleton className="h-3.5 w-1/2" />
      </div>
    </div>
  );
}

export function MessageSkeleton() {
  return (
    <div className="glass-card p-7 space-y-4" data-testid="skeleton-message">
      <Skeleton className="h-3.5 w-full" />
      <Skeleton className="h-3.5 w-5/6" />
      <Skeleton className="h-3.5 w-2/3" />
      <div className="flex justify-between pt-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-10" />
      </div>
    </div>
  );
}

export function ReflectionSkeleton() {
  return (
    <div className="max-w-3xl mx-auto glass-card p-12 md:p-16 flex flex-col items-center gap-4" data-testid="skeleton-reflection">
      <Skeleton className="h-8 w-8 rounded-full" />
      <Skeleton className="h-7 w-4/5" />
      <Skeleton className="h-7 w-3/5" />
      <Skeleton className="h-5 w-32 mt-3" />
    </div>
  );
}
